export let tableLabels = [{
  label: '检测平台名称',
  value: 'name'
}, {
  label: '检测周期(天)',
  value: 'testCycle'
}, {
  label: '创建人',
  value: 'creatorName'
}, {
  label: '创建时间',
  value: 'createdDate',
  minWidth: '120'
}]
